/* VapeMe theme scripts */
(function(){


  // Hero placeholder visuals (shown only until real banner images are added)
  var bottle = '<svg class="hbottle big" viewBox="0 0 60 90"><rect x="22" y="4" width="16" height="10" rx="3" fill="#ffffffaa"/><rect x="18" y="14" width="24" height="70" rx="8" fill="#ffffffcc"/><rect x="24" y="30" width="12" height="26" rx="3" fill="#fff"/></svg>';
  var vape = '<svg class="hbottle big" viewBox="0 0 60 90"><rect x="24" y="8" width="12" height="76" rx="6" fill="#ffffffcc"/><rect x="26" y="3" width="8" height="8" rx="3" fill="#ffffffaa"/></svg>';
  var v1 = document.getElementById('vis1'); if(v1) v1.innerHTML = bottle;
  var v2 = document.getElementById('vis2'); if(v2) v2.innerHTML = vape;

  // Hero slider
  var slides = document.querySelectorAll('.slide');
  var dots = document.querySelectorAll('.dots i');
  var si = 0;
  window.goSlide = function(i){
    slides.forEach(function(s){s.classList.remove('on')});
    dots.forEach(function(d){d.classList.remove('on')});
    if(slides[i]) slides[i].classList.add('on');
    if(dots[i]) dots[i].classList.add('on');
    si = i;
  };
  if(slides.length > 1){ setInterval(function(){ window.goSlide((si+1)%slides.length); }, 5000); }

  // Mobile menu
  window.toggleMob = function(s){
    var m = document.getElementById('mobmenu');
    if(m) m.classList.toggle('show', s);
  };
  // Mobile menu expandable categories
  window.mmToggle = function(btn){
    var group = btn.closest('.mm-group');
    if(group) group.classList.toggle('open');
  };
  // Product page quantity + variant
  window.pqty = function(d){
    var q = document.getElementById('pquantity');
    if(!q) return;
    q.value = Math.max(1, (parseInt(q.value)||1) + d);
  };
  window.pickVariant = function(form){};

  // Bulletproof: keep marquee + belt scrolling no matter what
  (function keepBeltsAlive(){
    function kick(el){
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
    }
    ['pageshow','focus'].forEach(function(ev){
      window.addEventListener(ev, function(){
        document.querySelectorAll('.marquee .track, .belt-track').forEach(kick);
      });
    });
    document.addEventListener('visibilitychange', function(){
      if(!document.hidden) document.querySelectorAll('.marquee .track, .belt-track').forEach(kick);
    });
    var last = {};
    setInterval(function(){
      document.querySelectorAll('.marquee .track, .belt-track').forEach(function(el, i){
        var x = el.getBoundingClientRect().left;
        if(last[i] !== undefined && Math.abs(last[i] - x) < 0.5){ kick(el); }
        last[i] = el.getBoundingClientRect().left;
      });
    }, 1000);
  })();

  (function cartSystem(){
    var drawer = document.getElementById('cartDrawer');
    var dOverlay = document.getElementById('drawerOverlay');
    var cdBody = document.getElementById('cdBody');
    var vpModal = document.getElementById('vpModal');
    var vpOverlay = document.getElementById('vpOverlay');
    var vpOptions = document.getElementById('vpOptions');
    var vpTitle = document.getElementById('vpTitle');
    var cartData = null;
    if(!cdBody || !drawer){ return; }
    function money(cents){ return (cents/100).toLocaleString('en-US') + ' kr'; }
        var vpSavedScroll = 0;
    function lockPage(){
      vpSavedScroll = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-vpSavedScroll) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.classList.add('vp-locked');
    }
    function unlockPage(){
      if(!document.body.classList.contains('vp-locked')) return;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.classList.remove('vp-locked');
      window.scrollTo(0, vpSavedScroll);
    }

    window.openDrawer = function(){ if(drawer){drawer.classList.add('open');dOverlay.classList.add('open');} };
    window.closeDrawer = function(){ if(drawer){drawer.classList.remove('open');dOverlay.classList.remove('open');} };
       window.closeVariantPopup = function(){ if(vpModal){vpModal.classList.remove('open');vpOverlay.classList.remove('open');unlockPage();} };

    function paintCart(cart){
      cartData = cart;
      var c=document.getElementById('citems');
      if(c){ c.textContent=cart.item_count; c.style.transform='scale(1.4)'; setTimeout(function(){c.style.transform='scale(1)';},150); }
      document.querySelectorAll('.cartpill .amt').forEach(function(el){ el.innerHTML=cart.item_count+' items - '+money(cart.total_price); });
      var fcC = document.getElementById('fcCount'); if(fcC){ fcC.textContent = cart.item_count; }
      if(cart.item_count===0){
        cdBody.innerHTML='<p class="cd-empty">Your cart is empty.</p>';
      } else {
        cdBody.innerHTML=cart.items.map(function(it){
          var variant = it.variant_title && it.variant_title!=='Default Title' ? '<div class="cdi-variant">'+it.variant_title+'</div>' : '';
          var img = it.image ? '<img src="'+it.image+'" alt="">' : '';
          var priceHtml = (it.original_price > it.final_price)
            ? '<div class="cdi-price"><s class="cdi-was">'+money(it.original_price)+'</s> <span class="cdi-now">'+money(it.final_price)+'</span></div>'
            : '<div class="cdi-price">'+money(it.final_price)+'</div>';
          var lineDisc = (it.line_level_discount_allocations||[]).map(function(d){
            return '<div class="cdi-disc">'+d.discount_application.title+' &minus;'+money(d.amount)+'</div>';
          }).join('');
          return '<div class="cd-item" data-key="'+it.key+'" data-unit="'+it.final_price+'">'+img+
            '<div class="cdi-info"><div class="cdi-name">'+it.product_title+'</div>'+variant+
            priceHtml + lineDisc +
            '<div class="cdi-qty"><button data-key="'+it.key+'" data-qty="'+(it.quantity-1)+'">&minus;</button><span>'+it.quantity+'</span><button data-key="'+it.key+'" data-qty="'+(it.quantity+1)+'">+</button></div></div>'+
            '<button class="cdi-remove" data-key="'+it.key+'" data-qty="0">&times;</button></div>';
        }).join('');
      }
      paintTotals(cart);
    }

    // Creates the discount rows above the subtotal if the theme markup has none
    function ensureTotalsUI(){
      var sub = document.getElementById('cdSubtotal');
      if(!sub || document.getElementById('cdDiscounts')) return;
      var row = sub.parentNode;
      if(!row || !row.parentNode) return;
      var box = document.createElement('div');
      box.id = 'cdDiscounts';
      box.className = 'cd-discounts';
      row.parentNode.insertBefore(box, row);
    }

    function paintTotals(cart){
      ensureTotalsUI();
      var sub = document.getElementById('cdSubtotal');
      if(sub) sub.textContent = money(cart.total_price);
      var box = document.getElementById('cdDiscounts');
      if(!box) return;
      var titles = {};
      (cart.cart_level_discount_applications||[]).forEach(function(d){
        titles[d.title] = (titles[d.title]||0) + d.total_allocated_amount;
      });
      (cart.items||[]).forEach(function(it){
        (it.line_level_discount_allocations||[]).forEach(function(d){
          var t = d.discount_application ? d.discount_application.title : 'Discount';
          titles[t] = (titles[t]||0) + d.amount;
        });
      });
      var rows = Object.keys(titles).map(function(t){
        return '<div class="cd-disc-row"><span class="cd-disc-name">'+t+'</span><span class="cd-disc-amt">&minus;'+money(titles[t])+'</span></div>';
      }).join('');
      if(rows){
        box.innerHTML = '<div class="cd-disc-row cd-disc-orig"><span>Original</span><span><s>'+money(cart.original_total_price)+'</s></span></div>' + rows;
        box.style.display = 'block';
      } else {
        box.innerHTML = '';
        box.style.display = 'none';
      }
      box.style.opacity = '1';
    }

    function fetchCart(){
      return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(paintCart);
    }

    // change qty — fully optimistic UI, debounced server sync
    var qtyTimers = {};

    function syncRowButtons(row, qty){
      if(!row) return;
      var minus = row.querySelector('.cdi-qty button:first-child');
      var plus  = row.querySelector('.cdi-qty button:last-child');
      if(minus) minus.setAttribute('data-qty', qty-1);
      if(plus)  plus.setAttribute('data-qty', qty+1);
    }

    function recalcTotals(){
      var total = 0, count = 0;
      cdBody.querySelectorAll('.cd-item').forEach(function(row){
        var unit = parseInt(row.getAttribute('data-unit'), 10) || 0;
        var span = row.querySelector('.cdi-qty span');
        var q = span ? (parseInt(span.textContent, 10) || 0) : 0;
        total += unit * q;
        count += q;
      });
      // With a threshold discount active the total can't be predicted locally,
      // so leave the money to the server response and only move the counts now.
      var hasDisc = !!(cartData && cartData.total_discount > 0);
      var shownTotal = hasDisc ? cartData.total_price : total;
      var sub = document.getElementById('cdSubtotal');
      if(sub && !hasDisc) sub.textContent = money(total);
      var dbox = document.getElementById('cdDiscounts');
      if(dbox && hasDisc) dbox.style.opacity = '0.5';
      var c = document.getElementById('citems');
      if(c) c.textContent = count;
      var fcC = document.getElementById('fcCount');
      if(fcC) fcC.textContent = count;
      document.querySelectorAll('.cartpill .amt').forEach(function(el){
        el.innerHTML = count + ' items - ' + money(shownTotal);
      });
    }

    function changeQty(key, qty, spanEl){
      if(qty < 0){ qty = 0; }
      var row = cdBody.querySelector('.cd-item[data-key="'+key+'"]');
      if(spanEl){ spanEl.textContent = qty; }
      syncRowButtons(row, qty);
      if(qty === 0 && row){ row.style.opacity = '0.4'; row.style.pointerEvents = 'none'; }
      recalcTotals();

      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function(){
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
          .then(function(r){ return r.json(); })
          .then(function(cart){
            var hadDisc = !!(cartData && cartData.total_discount > 0);
            var hasDisc = !!(cart && cart.total_discount > 0);
            // A discount appearing or disappearing changes every line's price,
            // so redraw the list in that case instead of patching numbers.
            if(qty === 0 || cart.item_count === 0 || hadDisc !== hasDisc){ paintCart(cart); return; }
            cartData = cart;
            var line = cart.items.filter(function(i){ return i.key === key; })[0];
            if(line && line.quantity !== qty){
              if(spanEl) spanEl.textContent = line.quantity;
              syncRowButtons(row, line.quantity);
            }
            paintTotals(cart);
            recalcTotals();
          })
          .catch(function(){ fetchCart(); });
      }, 250);
    }

    cdBody.addEventListener('click', function(e){
      var btn = e.target.closest('[data-key]');
      if(btn){
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'));
        var span = btn.parentNode ? btn.parentNode.querySelector('span') : null;
        changeQty(key, qty, span);
      }
    });

    function addToCart(variantId, btn, original, quantity){
      var qty = parseInt(quantity, 10);
      if(!qty || qty < 1){ qty = 1; }
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:variantId,quantity:qty})})
        .then(function(r){return r.json();})
        .then(function(){ return fetchCart(); })
        .then(function(){
          if(btn){ btn.innerHTML='&#10003; Added'; setTimeout(function(){btn.innerHTML=original;btn.disabled=false;},1000); }
        })
        .catch(function(){ if(btn){btn.innerHTML=original;btn.disabled=false;} });
    }

    document.addEventListener('submit', function(e){
      var form=e.target;
      if(!form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add')===-1) return;
      e.preventDefault();
      var btn=form.querySelector('button[type="submit"]');
      var original=btn?btn.innerHTML:'';
      var handle=form.getAttribute('data-handle');
      if(handle){ openVariantPopup(handle); return; }
      if(btn){btn.disabled=true;btn.innerHTML='Adding...';}
      var id=form.querySelector('[name="id"]').value;
      var qtyEl = form.querySelector('[name="quantity"]') || document.getElementById('pquantity');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      addToCart(id, btn, original, qty);
    });

    function openVariantPopup(handle){
      fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(p){
          vpTitle.textContent='Choose your flavor';
          vpOptions.innerHTML=p.variants.map(function(v){
            return '<button class="vp-opt" '+(v.available?'':'disabled')+' data-vid="'+v.id+'"><span>'+v.title+'</span><span class="vp-price">'+money(v.price)+'</span></button>';
          }).join('');
          vpModal.classList.add('open'); vpOverlay.classList.add('open'); lockPage();
        });
    }
    vpOptions.addEventListener('click', function(e){
      var b=e.target.closest('[data-vid]');
      if(!b) return;
      b.innerHTML='Adding...';
      closeVariantPopup();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:b.getAttribute('data-vid'),quantity:1})})
        .then(function(){ return fetchCart(); });
    });

    document.querySelectorAll('a.cartpill, a[href="/cart"]').forEach(function(link){
      if(link.classList.contains('cd-viewcart')) return;
      link.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); });
    });

    fetchCart();
  })();

  // Floating cart button — appears on scroll, syncs count, opens drawer
  (function floatingCart(){
    var fc = document.getElementById('floatingCart');
    if(!fc) return;
    window.addEventListener('scroll', function(){
      if(window.scrollY > 400){ fc.classList.add('show'); }
      else { fc.classList.remove('show'); }
    }, {passive:true});
    var headerCount = document.getElementById('citems');
    var fcCount = document.getElementById('fcCount');
    if(headerCount && fcCount){
      fcCount.textContent = headerCount.textContent
      new MutationObserver(function(){
        fcCount.textContent = headerCount.textContent;
      }).observe(headerCount, {childList:true, characterData:true, subtree:true});
    }
  })();

})();